<template>
  <el-radio
    :label="label"
    :border="border"
    :disabled="disabled"
    :data-qa="dataQa"
  >
    <div class="label">
      <div class="title">{{ title }}</div>
      <div class="description" v-if="description">{{ description }}</div>
    </div>
  </el-radio>
</template>

<script>
export default {
  name: 'Radio',

  props: {
    label: {
      required: true
    },

    title: {
      type: String,
      required: true
    },

    description: {
      type: String,
      required: false
    },

    border: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },

    dataQa: {
      type: String,
      required: false
    }
  }
}
</script>

<style scoped>
.el-radio {
  display: flex;
  border-color: #dbdee7;
  box-sizing: border-box;
  padding: 4px 14px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.el-radio.is-bordered {
  height: 54px;
  padding: 10px 14px;
}

.el-radio.is-bordered.is-checked {
  border-color: #1d87c8;
  background-color: #e6f3fb;
}

.el-radio >>> .el-radio__input {
  display: flex;
  align-items: center;
  flex: 0;
}

.el-radio >>> .el-radio__label {
  display: flex;
  align-items: center;
  padding-left: 14px;
  flex: 1;
}

.label {
  font-size: 14px;
  line-height: 18px;
}

.title {
  color: #5c6374;
}

.description {
  color: #7e8596;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/common/components/form/Radio.vue